// extracted by mini-css-extract-plugin
export default {"colorPrimary":"#2B5FF5","view":"r4zCG2nPEsj1L2Xi4OEl","mapView":"acN2eO4PWVhG1q3A5CEt","listView":"mFX4MuuP1ZbVIrLGvEEm","viewButton":"Yd27duK1sy7_3tvpnc2m"};